import React from "react";
import { ThankYou } from "../../../components";

export const ThankYouPage = () => {
  return <ThankYou />;
};
